<template>
  <div class="loading" v-show="isLoading">
    <div class="loading__circle"></div>
    <div class="loading__circle"></div>
    <div class="loading__circle"></div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppLoading.vue